// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

/* eslint-disable no-new */
var vueinit =  new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

import api from '../static/js/api'
Vue.prototype.$api = api
Vue.prototype.$img_head = 'http://img.oss.starfast.cn/'


import base from '../static/js/base'
Vue.use(base)

export default {
  vueinit:vueinit
}

//  百度统计
var _hmt = _hmt || [];
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
(function () {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?b9fd85c45686284e752247abc3d5af40";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();


import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

router.beforeEach((to,from,next)=>{
  NProgress.start()
  next()
})

router.afterEach(to=>{
  NProgress.done()

  if (_hmt) {
    if (to.path) {
      _hmt.push(['_trackPageview', '/#' + to.fullPath]);
    }
  }
})




// WEBPACK FOOTER //
// ./src/main.js